export default {"src":"/_next/static/media/eth-outline.a2c2023a.svg","height":41,"width":41};